export default __webpack_public_path__ + "static/media/FACEBOOK_v.fe5d2440.svg";